<template>
  <div id="mediahero">
    <div class="flex-container">
      <img class="logo" :src="logo" />
      <ApplyButton class="ApplyButton" v-bind:buttonText="buttonText" @click="func" />
      <Countdown ext_date="2020-08-31T20:59:59Z" class="Countdown" />
    </div>
    <img class="path" :src="path" />
  </div>
</template>

<script>
import ApplyButton from "@/components/global-components/ApplyButton";
import Countdown from "@/components/widgets/Countdown";

export default {
  components: {
    ApplyButton,
    Countdown,
  },
  data() {
    return {
      logo: require("@/assets/images/logo.png"),
      path: require("@/assets/images/HomeHeroPath.svg"),
      buttonText: "APLICĂ",
    };
  },
  methods: {
    func() {
      location.href='#/register';
    },
  },
};
</script>

<style scoped lang="scss">
#mediahero {
  // height: 100vh;
  width: 100%;
  height: $video-hero-height;
  height: 100vh;
  overflow: hidden;
  background-image: url("../../assets/images/imagine-fundal-min.png");
  background-size: cover;
  background-position: center;
  position: relative;
  margin-bottom: 0!important;
}

.ApplyButton {
  position: absolute;
  z-index: 99;
  left: 20vw;
  bottom: 10vh;
}

.Countdown {
  position: absolute;
  z-index: 99;
  right: 10vw;
  bottom: -2vh;
}

.logo {
  width: 30%;
  margin-top: 10%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.path {
  position: absolute;
  width: 100%;
  height: auto;
  bottom: -1.5vh;
}

// mobil (1024)
@media only screen and (max-width: 1024px) {
  .logo {
    width: 80vw;
    margin-top: 10vh;
  }

  #flex-container {
    width: 50vw;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .ApplyButton {
    margin-top: 10vh;
    position: static;
  }

  .Countdown {
    position: static;
    margin-top: 30vw!important;
  }
}
</style>



